import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import images from "../../../utilities/images/images";
import { useDashboardUserProfileQuery } from "../hooks/useStudyDashboardQueries";
import "./DashboardStreakButton.css";

const DashboardStreakButton = () => {
  const history = useHistory();
  const location = useLocation();

  const profileQuery = useDashboardUserProfileQuery();
  const profile = profileQuery.data;

  const [streakData, setStreakData] = useState(() => {
    try {
      const saved = sessionStorage.getItem("dashboard_streak_data");
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  const [showStreak, setShowStreak] = useState(() => {
    try {
      const saved = sessionStorage.getItem("dashboard_show_streak");
      return saved !== null ? Number(saved) : null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    if (!profile) return;
    const targets = profile.targets || [];
    const isShow = profile.show_streak || 0;
    setStreakData(targets);
    setShowStreak(isShow);
    try {
      sessionStorage.setItem("dashboard_streak_data", JSON.stringify(targets));
      sessionStorage.setItem("dashboard_show_streak", String(isShow));
    } catch {
      // ignore storage quota errors
    }
  }, [profile]);

  const resolvedShowStreak = profile
    ? Number(profile.show_streak) || 0
    : showStreak;
  const resolvedStreakData = profile?.targets ?? streakData;
  const showSkeleton =
    profileQuery.isLoading && resolvedShowStreak == null && !profile;

  if (
    location?.pathname === "/dashboard/streak" ||
    location?.pathname.startsWith("/dashboard/streak/")
  ) {
    return null;
  }

  // Skeleton only before any profile cache or session value exists.
  if (showSkeleton) {
    return (
      <div
        className="dashboard-streak-btn dashboard-streak-btn--skeleton"
        aria-hidden="true"
      >
        <div className="dashboard-streak-btn__skeleton-circle" />
        <div className="dashboard-streak-btn__skeleton-lines">
          <div className="dashboard-streak-btn__skeleton-line dashboard-streak-btn__skeleton-line--top" />
          <div className="dashboard-streak-btn__skeleton-line dashboard-streak-btn__skeleton-line--bottom" />
        </div>
      </div>
    );
  }

  if (resolvedShowStreak !== 1) {
    return null;
  }

  const totalStreak = resolvedStreakData?.[0]?.total_streak ?? 0;

  return (
    <div
      className="dashboard-streak-btn"
      onClick={() => history.push("/dashboard/streak")}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && history.push("/dashboard/streak")}
    >
      <div className="dashboard-streak-btn__img">
        <img src={images.streak} alt="streak" />
      </div>
      <div className="dashboard-streak-btn__info">
        <div className="dashboard-streak-btn__count">{totalStreak} Streaks</div>
        <div className="dashboard-streak-btn__label">Start Now</div>
      </div>
      <div className="dashboard-streak-btn__arrow">
        <img src={images.right_Ar} alt="arrow" style={{ width: "7px" }} />
      </div>
    </div>
  );
};

export default DashboardStreakButton;
